/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Delete_Failed2Inputs */

const vi_cmspostcategory_delete_failed2 = /** @type {(inputs: Cmspostcategory_Delete_Failed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xoá được chuyên mục. Kiểm tra mạng rồi thử lại.`)
};

/**

* @param {Cmspostcategory_Delete_Failed2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_delete_failed2 = /** @type {((inputs?: Cmspostcategory_Delete_Failed2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Delete_Failed2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_delete_failed2(inputs)
});
export { cmspostcategory_delete_failed2 as "cmsPostCategory_delete_failed" }